import { Col, Row } from "@commonlibs";
import FullLogo from "../../display/FullLogo/FullLogo";
import AppTabs from "../AppTabs/AppTabs";
import { AppBarHeader, AppBarHeaderContent, AppBarRoot } from "./AppBar.styles";
import UserMenu from "../../../../user/containers/UserMenu/UserMenu";
import AppRoleSelect from "ui/user/containers/AppRoleSelect/AppRoleSelect";
import type { RoleDto } from "common/models/api/models/RoleDto";
import { useState } from "react";

const AppBar = (): JSX.Element => {
    const [selectedRole, setSelectedRole] = useState<RoleDto>();

    function onSelectRole(role: RoleDto) {
        setSelectedRole(role);
    }

    return (
        /* skipcq: JS-0415 */
        <AppBarRoot>
            <Col css={{ height: "100%" }} justifyContent="space-between">
                <AppBarHeader alignItems="center" justifyContent="space-between">
                    <AppBarHeaderContent alignItems="center" justifyContent="space-between" flex={1}>
                        <FullLogo color="primary" size="md" variant="purple" style={{ width: "6rem" }} />
                        <Row gap="0.75rem">
                            <AppRoleSelect onSelectRole={onSelectRole} />
                            <UserMenu />
                        </Row>
                    </AppBarHeaderContent>
                </AppBarHeader>
                <AppTabs selectedRole={selectedRole} />
            </Col>
        </AppBarRoot>
    );
};

export default AppBar;
